'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @since 2017-05-18 14:43:16
 * @author vivaxy
 */

var ARRAY = exports.ARRAY = [];

var NOOP = exports.NOOP = function NOOP() {};

var OOPS = exports.OOPS = function OOPS() {
  return {};
};

var OOPSTRING = exports.OOPSTRING = function OOPSTRING() {
  return '';
};

var RETURNING_PARAM = exports.RETURNING_PARAM = function RETURNING_PARAM(arg) {
  return arg;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/values.js
// module id = 237
// module chunks = 0